import { CommonModule } from '@angular/common';
import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { ContentComponentForPopUpComponent } from 'ib/internetbank-core/ib-components/pop-ups/pop-up/pop-up.component';
import { ShareButtonComponent } from 'ib/internetbank-core/ib-components/share-button/share-button.component';


@Component({
	selector: 'app-pdf-viewer-content-component-for-popup-component',
	templateUrl: './pdf-viewer.content-component-for-popup-component.html',
	styleUrls: ['./pdf-viewer.content-component-for-popup-component.less'],
	imports: [
		CommonModule,
		NgxExtendedPdfViewerModule,
		ShareButtonComponent,
	],
})
export class PdfViewerContentComponentForPopupComponentComponent extends ContentComponentForPopUpComponent implements OnInit {

	@Input()
	public title: string | undefined;

	@Input()
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public src: string | ArrayBuffer | Blob | Uint8Array | URL | { range: any; } | undefined;

	@Input()
	public base64Src: string | null | undefined;

	@Input()
	public height: string;

	@Input()
	public shareData?: ShareData;


	@Output()
	public agreementResult: EventEmitter<boolean> = new EventEmitter<boolean>();


	public ngOnInit(): void {
	}

	public onClose() {
		this.closePopup?.();
	}

}
